import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './routes/router'
import VueWait from 'vue-wait'
import i18n from './i18n'
import vuetify from './plugins/vuetify'
import VueMeta from 'vue-meta'
import VueHead from 'vue-head'
import './plugins/vuegtm'




import * as Sentry from "@sentry/vue";
import {
  Integrations
} from "@sentry/tracing";
import './plugins/sentry'

Sentry.init({
  Vue,
  dsn: "https://9b8cb594f994495f8014f9eccb2a3bed@o255934.ingest.sentry.io/5839329",
  integrations: [new Integrations.BrowserTracing()],
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
});


Vue.use(VueHead)
Vue.use(VueMeta)
Vue.use(VueWait)

Vue.config.productionTip = false

new Vue({
  render: (h) => h(App),
  router,
  store,
  wait: new VueWait(),
  vuetify,
  i18n,
}).$mount('#vadain')
